export default function fileTtfSvg () {
  return `
    <svg id="file-font-svg" width="160" height="130" viewBox="0 0 512 512">
      <use xlink:href="/img/icons/file-font.svg#file-font-svg" ></use>
    </svg>
  `
}
